var progressTimeout = null;

window.progress =
{
    show: function ()
    {
        progressTimeout = setTimeout(function ()
        {
            document.querySelector("#boxprogress").classList.add("progressactive");
        }, 250);
    },
    hide: function ()
    {
        clearTimeout(progressTimeout);

        document.querySelector("#boxprogress").classList.remove("progressactive");
    }
};